import { action, createStore } from "easy-peasy"

export default createStore({
	// GENERAL
	Expired: false,
	setExpired: action((state, payload) => {
		state.Expired = payload
	}),
	NavSelected: "",
	setNavSelected: action((state, payload) => {
		state.NavSelected = payload
	}),
	NavSubSelected: "",
	setNavSubSelected: action((state, payload) => {
		state.NavSubSelected = payload
	}),

	// LOGIN SCREEN
	Login: "",
	setLogin: action((state, payload) => {
		state.Login = payload
	}),
	Pswd: "",
	setPswd: action((state, payload) => {
		state.Pswd = payload
	}),
	Email: "",
	setEmail: action((state, payload) => {
		state.Email = payload
	}),
	Firstname: "",
	setFirstname: action((state, payload) => {
		state.Firstname = payload
	}),
	Lastname: "",
	setLastname: action((state, payload) => {
		state.Lastname = payload
	}),
	County: "",
	setCounty: action((state, payload) => {
		state.County = payload
	}),
	BreedList: [],
	setBreedList: action((state, payload) => {
		state.BreedList = payload
	}),
	DistrictList: [],
	setDistrictList: action((state, payload) => {
		state.DistrictList = payload
	}),
	ParcelDistrictList: [],
	setParcelDistrictList: action((state, payload) => {
		state.ParcelDistrictList = payload
	}),

	FeeList: [],
	setFeeList: action((state, payload) => {
		state.FeeList = payload
	}),
	ErrorMsg: "",
	setErrprMsg: action((state, payload) => {
		state.ErrorMsg = payload
	}),
	ClientId: 0,
	setClientId: action((state, payload) => {
		state.ClientId = payload
	}),
	LoggedIn: false,
	setLoggedIn: action((state, payload) => {
		state.LoggedIn = payload
	}),
	Token: "",
	setToken: action((state, payload) => {
		state.Token = payload
	}),

	AuthUser: false,
	setAuthUser: action((state, payload) => {
		state.AuthUser = payload
	}),
	AuthLicense: false,
	setAuthLicense: action((state, payload) => {
		state.AuthLicense = payload
	}),
	AuthAnimal: false,
	setAuthAnimal: action((state, payload) => {
		state.AuthAnimal = payload
	}),
	AuthDMV: false,
	setAuthDMV: action((state, payload) => {
		state.AuthDMV = payload
	}),
	AuthPermits: false,
	setAuthPermits: action((state, payload) => {
		state.AuthPermits = payload
	}),
	AuthService: false,
	setAuthService: action((state, payload) => {
		state.AuthService = payload
	}),
	AuthDashboard: false,
	setAuthDashboard: action((state, payload) => {
		state.AuthDashboard = payload
	}),
	AuthFarm: false,
	setAuthFarm: action((state, payload) => {
		state.AuthFarm = payload
	}),
	IsDeputy: false,
	setIsDeputy: action((state, payload) => {
		state.IsDeputy = payload
	}),
	AuthJournal: false,
	setAuthJournal: action((state, payload) => {
		state.AuthJournal = payload
	}),
	AuthPersonalProp: false,
	setAuthPersonalProp: action((state, payload) => {
		state.AuthPersonalProp = payload
	}),
	AuthReports: false,
	setAuthReports: action((state, payload) => {
		state.AuthReports = payload
	}),
	SearchPrompt: [],
	setSearchPrompt: action((state, payload) => {
		state.SearchPrompt = payload
	}),
	SearchBy: [],
	setSearchBy: action((state, payload) => {
		state.SearchBy = payload
	}),

	EnvSuffix: "",
	setEnvSuffix: action((state, payload) => {
		state.EnvSuffix = payload
	}),

	// THEME default is 2 = full screen dark blue
	// 0 = box 800 wide
	// 1 = full screen light blue
	// 3 = full screen dark green
	// 4 = full scree light green
	Theme: 2,
	setTheme: action((state, payload) => {
		state.Theme = payload
	}),
	// HEADER
	HeaderCity: "CR Cloud Technology",
	setHeaderCity: action((state, payload) => {
		state.HeaderCity = payload
	}),
	HeaderUser: "None",
	setHeaderUser: action((state, payload) => {
		state.HeaderUser = payload
	}),

	// USER SCREEN
	Status: "",
	setStatus: action((state, payload) => {
		state.Status = payload
	}),

	// USER MODULE SCREEN
	Grants: "",
	setGrants: action((state, payload) => {
		state.Grants = payload
	}),
	selectedUser: "",
	setSelectedUser: action((state, payload) => {
		state.selectedUser = payload
	}),

	// RATE SCREEN
	selectedRate: "",
	setSelectedRate: action((state, payload) => {
		state.selectedRate = payload
	}),
})
